import { render, staticRenderFns } from "./EditCategoryModal.vue?vue&type=template&id=8fa1ca94&"
import script from "./EditCategoryModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EditCategoryModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports